<template>
  <q-dialog
    v-model="dialog"
    persistent
    style="width: 600px"
    class="text-uppercase"
  >
    <q-card class="custom-font pragma-black">
      <q-card-section class="q-pa-none">
        <q-toolbar class="bg-pragma text-white">
          <span class="text-bold">Historial de la solicitud</span>
          <q-space></q-space>
          <q-btn
            icon="clear"
            @click="closeDialog()"
            flat
          ></q-btn>
        </q-toolbar>
      </q-card-section>
      <q-card-section>
        <q-list bordered separator dark>
          <q-item
            clickable
            v-ripple
            v-for="(estado,index) in estados"
            :key="index"
            :class="index%2 == 0 ? 'bg-grey-9' : 'bg-grey-10'"
          >
            <q-item-section>
              <q-item-label>{{estado.usuario}}</q-item-label>
              <q-item-label caption>{{vmoment(estado.fecha, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}}</q-item-label>
              <q-item-label caption>{{estado.descripcion}}</q-item-label>
            </q-item-section>

            <q-item-section side top>
              <q-badge color="blue-grey" style="min-width: 50px">
                <div class="row items-center text-center full-width">
                  <div class="col-xs-12">
                    {{estado.codigo}}
                  </div>
                </div>
              </q-badge>
              <q-icon name="computer" class="q-pt-lg text-white" v-if="estado.platform === 'W'"></q-icon>
              <q-icon name="android" class="q-pt-lg" color="positive" v-if="estado.platform === 'A'"></q-icon>
              <div class="row full-width text-right q-pt-lg" v-if="estado.platform === 'I'">
                <div class="col">
                  <q-img src="assets/apple_icon.svg" style="width: 45%"></q-img>
                </div>
              </div>
            </q-item-section>
            
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import moment from 'moment'

export default {
  setup () {
    // Variables reactivas y no reactivas
    const dialog = ref(false)
    const bus = inject('bus')
    const estados = ref([])
    const vmoment = moment

    // Métodos y funciones del componente
    const closeDialog = () => {
      estados.value = []
      dialog.value = false
    }
    // Creación del componente
    bus.on('openDialogHistorialSolicitud', (item) => {
      item.estados.forEach(elem => {
        const temp = elem.estado.split('|')
        const estado = {
          usuario: temp[0],
          codigo: temp[1],
          descripcion: temp[2],
          platform: temp[3],
          fecha: elem.created_at
        }
        estados.value.push(estado)
      })
      dialog.value = true
    })
    return {
      dialog,
      estados,
      closeDialog,
      vmoment
    }
  }
}
</script>

<style>

</style>